import { render, staticRenderFns } from "./AddScopes.vue?vue&type=template&id=6173dcc2"
import script from "./AddScopes.vue?vue&type=script&lang=js"
export * from "./AddScopes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports